<template>

  <!-- Admin画面（URLに #admin が付いている場合） -->
  <AdminView v-if="isAdmin" />

  <template v-else>
  <HeaderArea />
  <div class="page">
    <div class="page_content_form" v-if="isOubo">
      <OuboForm @close_form="handleCloseForm" />
    </div>

    <!-- 採用選考におけるハラスメント相談窓口（URLに #harassment でも直接表示） -->
    <div class="page_content_form" v-if="isHarassment">
      <HarassmentConsultForm @close_form="handleCloseHarassment" />
    </div>

    <div v-if="isPageContent">

      <!-- ヒーローセクション（案B） -->
      <div class="hero_section">
        <div class="hero_inner">
          <p class="hero_eyebrow">エンジニアのキャリアを、もっと自由に。</p>
          <h1 class="hero_title">あなたの「やってみたい」を<br>MIKで実現しませんか。</h1>
          <p class="hero_desc">
            未経験からでも、経験者でも。<br>
            まずは気軽に話してみてください。
          </p>
          <p class="hero_locations">北海道・盛岡・東京・大阪・福岡にも仲間がいます</p>
          <button class="hero_cta" @click="handleShowForm">カジュアル面談してみる →</button>
        </div>
      </div>





      <div class="page_content">


        <div class="scroll_container">

          <div class="content">
            <div class="box_message">
              <h2>積極採用中</h2>
              <ul>
                <li>
                  <h4>未経験エンジニア</h4>
                </li>
                <li>
                  <h4>キャリアエンジニア</h4>
                </li>
              </ul>

            </div>

          </div>

          <div>
            <h4>おかげさまで全国の経験者・未経験者エンジニア様から<br>
              多くのカジュアル面談のお申し込みを頂き、<br>
              MIKに入ってよかった、とのお声をいただいております。
            </h4>

          </div>


          <div class="content">
            <img src="@/assets/scroll.svg" width="120px">
          </div>

          <div class="main_item" @click="handleOpenAboutUs" v-if="!isOpenAboutUs">
            <img src="@/assets/whats_mik.svg" alt="">
          </div>

          <div class="content" v-if="isOpenAboutUs">
            <AboutUs />
          </div>

          <div class="main_item" @click="handleOpenAboutWelfare" v-if="!isOpenAboutWelfare">
            <img src="@/assets/walfare.svg" alt="">
          </div>

          <div v-if="isOpenAboutWelfare" id='about_work' ref='about_work'>
            <AboutWelfare />
          </div>




          <div class="main_item" @click="handleOpenAboutMember" v-if="!isOpenAboutMember">
            <img src="@/assets/members_img.svg" alt="">
          </div>

          <div v-if="isOpenAboutMember" id='about_work' ref='about_work'>
            <MemberSelect />
          </div>

          <div class="main_item" @click="handleOpenAboutWorkday" v-if="!isOpenAboutWorkday">
            <img src="@/assets/day.svg" alt="">
          </div>

          <div v-if="isOpenAboutWorkday" id='about_work' ref='about_work'>
            <WorkDay />
          </div>

          <div class="content">
            <div class="bold_message_center">
              <h3>「ちょっとやってみようかな」<br>
                と思ったそこのあなた。<br>
                その気持ち<br>
                大事にしませんか。</h3>
            </div>
          </div>

          <div class="oubo_btn2" @click="handleShowForm">
            MIKの採用担当と<br>カジュアル面談してみる
          </div>


          <SaiyoFlow />

          <YokuaruQA />


        </div>
      </div>
    </div>

    <FooterArea @open_harassment="handleShowHarassment" />

  </div>
  </template>




</template>

<script>

import AboutUs from './components/AboutUs.vue';
import AboutWelfare from './components/AboutWelfare.vue';
import AdminView from './components/AdminView.vue';
import FooterArea from './components/FooterArea.vue';
import HarassmentConsultForm from './components/HarassmentConsultForm.vue';
import HeaderArea from './components/HeaderArea.vue';
import MemberSelect from './components/MemberSelect.vue';
import OuboForm from './components/OuboForm.vue';
import SaiyoFlow from './components/SaiyoFlow.vue';

import WorkDay from './components/WorkDay.vue';
import YokuaruQA from './components/YokuaruQA.vue';




export default {
  name: 'App',
  components: {
    MemberSelect, SaiyoFlow, YokuaruQA, AboutUs, AboutWelfare,
    WorkDay, FooterArea, HeaderArea, OuboForm, AdminView, HarassmentConsultForm
  },
  data() {
    return {
      isOpenAboutUs: false,
      isOpenAboutWelfare: false,
      isOpenAboutWorkday: false,
      isOpenAboutMember: false,
      isOubo: false,
      isPageContent: !window.location.hash.startsWith('#harassment'),
      isHarassment: window.location.hash.startsWith('#harassment'),
      isAdmin: window.location.hash.startsWith('#admin'),
    }
  },
  methods: {
    showSubMenu(index) {
      this.navItems[index].show = true;
    },
    hideSubMenu(index) {
      this.navItems[index].show = false;
    },
    handleShowForm() {
      this.isOubo = true;
      this.isPageContent = false;
    },
    handleCloseForm() {
      this.isOubo = false;
      this.isPageContent = true;
    },
    handleShowHarassment() {
      this.isOubo = false;
      this.isHarassment = true;
      this.isPageContent = false;
      window.scrollTo({ top: 0 });
    },
    handleCloseHarassment() {
      this.isHarassment = false;
      this.isPageContent = true;
    },
    handleOpenAboutUs() {
      this.isOpenAboutUs = !this.isOpenAboutUs;

    },
    handleOpenAboutWelfare() {
      this.isOpenAboutWelfare = !this.isOpenAboutWelfare;

    },
    handleOpenAboutWorkday() {
      this.isOpenAboutWorkday = !this.isOpenAboutWorkday;

    },
    handleOpenAboutMember() {
      this.isOpenAboutMember = !this.isOpenAboutMember;

    },
    handleOpenMenu(select_num) {

      console.log("push_openmenu")

      let section = "";
      let isSection = false;

      switch (select_num) {


        case 1:
          this.isOpenAboutUs = !this.isOpenAboutUs;
          this.isOpenAboutWork = false;
          this.isOpenAboutTraining = false;
          this.isOpenAboutAssignment = false;

          section = 'about_us'
          isSection = this.isOpenAboutUs;

          break;
        case 2:
          this.isOpenAboutWork = !this.isOpenAboutWork;
          this.isOpenAboutUs = false;
          this.isOpenAboutTraining = false;
          this.isOpenAboutAssignment = false;

          section = 'about_work'
          isSection = this.isOpenAboutWork;
          break;
        case 3:
          this.isOpenAboutTraining = !this.isOpenAboutTraining;
          this.isOpenAboutUs = false;
          this.isOpenAboutWork = false;
          this.isOpenAboutAssignment = false;

          section = 'about_training'
          isSection = this.isOpenAboutTraining;
          break;
        case 4:
          this.isOpenAboutAssignment = !this.isOpenAboutAssignment;
          this.isOpenAboutUs = false;
          this.isOpenAboutTraining = false;
          this.isOpenAboutWork = false;

          section = 'about_assignment'
          isSection = this.isOpenAboutAssignment;
          break;
        default:
          break;
      }

      console.log(section);


      this.$nextTick(() => {

        if (isSection) {
          const sectionElement = this.$refs[section]
          if (sectionElement) {
            sectionElement.scrollIntoView({ behavior: 'smooth' });
          }

        }

      })




    },
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  color: black;

}

body {
  margin: 0;
}

navi {
  display: flex;
  align-items: center;
  justify-content: center;
}

.page {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;

}

/* ヒーローセクション（案B） */
.hero_section {
  width: 100%;
  background: linear-gradient(160deg, #f8fbff 0%, #eaf6fb 100%);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 80px 20px 70px;
  box-sizing: border-box;
  border-bottom: 1px solid #e0eef5;
}

.hero_inner {
  max-width: 720px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.hero_eyebrow {
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 0.06em;
  color: #0cc0df;
  margin: 0;
}

.hero_title {
  font-size: 40px;
  font-weight: 800;
  color: #1a2a3a;
  line-height: 1.55;
  margin: 0;
}

.hero_desc {
  font-size: 18px;
  color: #4a6070;
  line-height: 1.9;
  margin: 0;
}

.hero_locations {
  font-size: 14px;
  color: #7a99aa;
  background: rgba(12, 192, 223, 0.08);
  border: 1px solid rgba(12, 192, 223, 0.25);
  border-radius: 20px;
  padding: 7px 22px;
  margin: 0;
}

.hero_cta {
  margin-top: 8px;
  padding: 18px 48px;
  background-color: #0cc0df;
  color: #fff;
  border: none;
  border-radius: 30px;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
  transition: 200ms;
  box-shadow: 0 4px 16px rgba(12, 192, 223, 0.35);
}

.hero_cta:hover {
  background-color: #0aa8c4;
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(12, 192, 223, 0.45);
}


.nav_list {
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.nav_item {
  width: 250px;
  height: 40px;
  background-color: #fff;
  margin: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #2c3e50;
}



.flex {
  width: 100%;
  display: flex;
  justify-content: space-around;
}





.content {
  width: 100%;
  height: auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  padding-top: 48px;
  padding-bottom: 48px;
}

.page_content {
  background-color: #f4f8fb;
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
}

.scroll_container {
  width: 100%;
  height: 100%;
  background-color: transparent;
  display: flex;
  overflow-y: auto;
  flex-direction: column;
  align-items: center;
}

.content_video {
  width: 100%;
  height: auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  align-items: center;



}



.content_pickup {
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: #C1FF72;
  align-items: center;
}

.content_schedule {
  padding-top: 80px;
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;

  align-items: center;
}




.item_box {
  width: 100%;
  display: flex;
  flex-wrap: wrap;

}

.item {
  width: 320px;
  height: 280px;
  background-color: #fff;
  border-radius: 10px;
  padding: 20px;
  margin: 20px;
  text-align: center;
  border: 2px solid black;
  position: relative
}

.main_item {
  width: 340px;
  height: 260px;
  background-color: #fff;
  border-radius: 14px;
  padding: 20px;
  margin: 16px;
  border: 2px solid #e0eef5;
  box-shadow: 0 2px 10px rgba(12, 192, 223, 0.08);
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 300ms;
  cursor: pointer;
}

.main_item img {
  width: 300px;
}

.main_item:hover {
  transition: 300ms;
  transform: scale(1.04);
  border-color: #0cc0df;
  box-shadow: 0 4px 16px rgba(12, 192, 223, 0.18);
}





.pickup_items {
  display: flex;
  flex-wrap: wrap;
  max-width: 1000px;
  justify-content: center;

}

.pickup_item {
  width: 420px;
  height: 280px;
  background-color: #fff;
  border-radius: 5px;
  padding: 20px;
  margin: 20px;
  text-align: center;

  box-shadow: 10px 10px, -0.2em 0 .4em rgb(129, 129, 95);
}

.schedule_box {
  width: 800px;
  height: 500px;
  background-color: #fff;
  border-radius: 5px;
  padding: 20px;
  margin: 20px;
  text-align: center;

  box-shadow: 10px 10px, -0.2em 0 .4em rgb(129, 129, 95);
}



.schedule_table {
  width: 700px;
  border: 1px solid #ddd;
  border-collapse: collapse;
}

.schedule_table th {

  border: 1px solid #ddd;
}

.schedule_table td {

  border: 1px solid #ddd;
  height: 80px;
}





.page_content_form {
  background-image: url('@/assets/back.svg');

  /* 中央に配置 */
  width: 100%;
  height: auto;
  padding: 50px 0 50px 0;

  display: flex;
  justify-content: center;


}

.bold_message_center {
  line-height: 1.8;
  text-align: center;
}

.bold_message_center h3 {
  font-size: 22px;
  font-weight: 800;
  color: #1a2a3a;
  margin: 0;
}

.box_message {
  border: 2px solid #0cc0df;
  border-radius: 14px;
  width: 380px;
  padding: 28px 32px;
  background: #fff;
  box-shadow: 0 2px 12px rgba(12, 192, 223, 0.1);
}

.box_message h2 {
  font-size: 24px;
  margin: 0 0 14px 0;
  color: #1a2a3a;
}

.box_message ul {
  padding-left: 18px;
  margin: 0;
}

.box_message li h4 {
  font-size: 18px;
  margin: 6px 0;
  color: #2c3e50;
}

.oubo_btn2 {
  padding: 20px 48px;
  background-color: #0cc0df;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  font-weight: bold;
  border-radius: 30px;
  cursor: pointer;
  box-shadow: 0 4px 16px rgba(12, 192, 223, 0.35);
  transition: 200ms;
  text-align: center;
  line-height: 1.5;
}

.oubo_btn2:hover {
  background-color: #0aa8c4;
  transform: translateY(-2px);
}

@media(max-width:500px) {
  body {
    width: 100%;
    margin: 0px;
    ;
  }

  .page {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .hero_section {
    padding: 70px 16px 60px;
  }

  .hero_title {
    font-size: 26px;
  }

  .box_message {
    width: 250px;
  }



  .main_item {
    width: 300px;
    height: 280px;
    box-sizing: border-box;
  }

  .page_content {
    width: 320px;
    box-sizing: border-box;
  }

  .page_content_form {
    width: 320px;
    box-sizing: border-box;
  }

  .oubo_btn2 {
    width: 200px;
    height: 100px;
    background-color: deepskyblue;
    ;
    color: #fff;
    display: flex;

    justify-content: center;
    align-items: center;
    font-size: 18px;
    font-weight: bold;
    border-radius: 0px;
    padding: 20px;
    border-radius: 20px;
  }
}
</style>
